<script lang="ts" setup>
const props = defineProps<{
  file: string
}>()

interface CodeBlockFile {
  document: ParsedContent
  surround: {
    after?: ParsedContent
    before?: ParsedContent
  }
}

const { data, refresh } = await useAsyncData<CodeBlockFile>(`code-block-${props.file}`, () => $fetch<CodeBlockFile>(`/api/server/content/${props.file}?collection=code`))

watch(
  () => props.file,
  () => refresh(),
)
</script>

<template>
  <div class="w-full overflow-auto rounded-lg bg-gray-900/95 p-4 ring-1 ring-gray-800 dark:bg-gray-950/50 dark:ring-gray-900">
    <div class="prose">
      <ContentRenderer
        v-if="data"
        :value="data.document"
      />
    </div>
  </div>
</template>

<style scoped lang="postcss">
:deep(pre) {
  @apply overflow-auto !bg-transparent !p-0;
}

:deep([data-content-id]) {
  @apply w-full;
}
</style>
